var ConnectionHubHelper = (function () {

  function _connectionStateChanged(state, onConnectedFunc) {
    const stateConversion = { 0: 'connecting', 1: 'connected', 2: 'reconnecting', 4: 'disconnected' };
    console.log('SignalR изменил состояние с: ' + stateConversion[state.oldState]
      + ' на: ' + stateConversion[state.newState]);

    if(onConnectedFunc && state.newState === 1){
      onConnectedFunc();
    }
  }

  // Открывает соединение с SignalR Hub
  // В качестве параметра 'url' принимает url хаба, который будем слушать
  // В качестве параметра 'onConnectedFunc' принимает функцию, которая будет выполнена при подключении
  function _start(url, onConnectedFunc) {
    if (url) {
      $.connection.hub.url = url;
    }

    $.connection.hub.stateChanged(state=> {
      _connectionStateChanged(state, onConnectedFunc);
    });
    $.connection.hub.start();
    $.connection.hub.disconnected(function () {
      setTimeout(function () {
        $.connection.hub.start();
      }, 5000); // Restart connection after 5 seconds.
    });
  }

  return { start: _start };
}());
